import { TaskStatusBadgeController } from './task-status-badge.controller'

const component = {
  templateUrl: '/workflow/components/task-status-badge/task-status-badge.html?$$REVISION$$',
  bindings: {
    task: '<',
    variations: '@'
  },
  controllerAs: '$ctrl',
  controller: TaskStatusBadgeController
}

export const taskStatusBadge = component
